export const STORED_THEME = "STORED_THEME";
export const STORED_THEME_SUCCESS = "STORED_THEME_SUCCESS";
export const STORED_THEME_FAIL = "STORED_THEME_FAIL";
export const USER_CONFIGURATION = "USER_CONFIGURATION";
export const USER_CONFIGURATION_SUCCESS = "USER_CONFIGURATION_SUCCESS";
export const USER_CONFIGURATION_FAIL = "USER_CONFIGURATION_FAIL";
